import { isEmpty } from 'es-toolkit/compat';
import { z } from 'zod';

import { IntegrationUsageLogStatus, IntegrationUsageLogWhere } from 'src/api';
import { INTEGRATION_USAGE_LOG_ENDPOINTS } from 'src/constants/integrationUsageLog';
import { FilterItem } from 'src/providers/FilterStorageProvider/types';

const endpointValues = Object.values(INTEGRATION_USAGE_LOG_ENDPOINTS) as [string, ...string[]];

const filterSchema = z.object({
  createdAtFrom: z.string().nullish(),
  createdAtTo: z.string().nullish(),
  endpoint: z.array(z.enum(endpointValues)).nullish(),
  status: z.array(z.enum(IntegrationUsageLogStatus)).nullish(),
});

export const prepareIntegrationUsageLogsFilter = (
  filter: FilterItem,
  integrationId: string,
): IntegrationUsageLogWhere => {
  const where: IntegrationUsageLogWhere = { integrationId: { equals: integrationId } };

  if (isEmpty(filter)) return where;

  const parsedFilter = filterSchema.safeParse(filter).data;

  if (parsedFilter?.createdAtFrom || parsedFilter?.createdAtTo) {
    where.createdAt = {
      ...(parsedFilter.createdAtFrom && { gte: parsedFilter.createdAtFrom }),
      ...(parsedFilter.createdAtTo && { lte: parsedFilter.createdAtTo }),
    };
  }

  if (parsedFilter?.endpoint && !isEmpty(parsedFilter.endpoint)) {
    where.endpoint = { in: parsedFilter.endpoint };
  }

  if (parsedFilter?.status && !isEmpty(parsedFilter.status)) {
    where.status = { in: parsedFilter.status };
  }

  return where;
};
